import http from '../utils/http';
import { ENGAGEMENT_STATUS_URL } from '../constants/endpoints';

export async function fetchAll() {
  return await http.get(ENGAGEMENT_STATUS_URL);
}
